/**
 * Do not change this file manually! This file was generated with the "Dicebear Exporter"-Plugin for Figma.
 *
 * Plugin: https://www.figma.com/community/plugin/1005765655729342787
 */

/*!
 * My Avatar Style (@dicebear/my-avatar-style)
 *
 * Code licensed under MIT License.
 * Copyright (c) 2025 Florian Körner
 *
 * Design "My Avatar Style" licensed under CC BY 4.0. / Remix of the original.
 * License: https://creativecommons.org/licenses/by/4.0/
 */

import type { StyleCreate, StyleMeta } from '@dicebear/core';
import { escape } from '@dicebear/core';

import type { Options } from './types.js';
import { getColors } from './utils/getColors.js';
import { getComponents } from './utils/getComponents.js';

export const meta: StyleMeta = {
  title: 'My Avatar Style',
  license: {
    name: 'CC BY 4.0',
    url: 'https://creativecommons.org/licenses/by/4.0/',
  },
};

export const create: StyleCreate<Options> = ({ prng, options }) => {
  const components = getComponents({ prng, options });
  const colors = getColors({ prng, options });

  return {
    attributes: {
      viewBox: '0 0 100 100',
      fill: 'none',
      'shape-rendering': 'auto',
    },
    body: `<rect width="100" height="100" fill="${escape.xml(`${colors.bgg}`)}"/>${components.goon1?.value(components, colors) ?? ''}${components.wave1?.value(components, colors) ?? ''}${components.wave2?.value(components, colors) ?? ''}${components.wave3?.value(components, colors) ?? ''}`,
    extra: () => ({
      ...Object.entries(components).reduce<Record<string, string | undefined>>((acc, [key, value]) => {
        acc[key] = value?.name;
        return acc;
      }, {}),
      ...Object.entries(colors).reduce<Record<string, string>>((acc, [key, value]) => {
        acc[`${key}Color`] = value;
        return acc;
      }, {}),
    }),
  };
};

export { schema } from './schema.js';
export type { Options } from './types.js';
